<div class="header-class">
    <h2 class="h2-class">Select Travel Date</h2>
</div>
<div class="search-container">
    <div class="calendar-container">
        <label for="full-calendar-date">Travel date</label>
        <input
          id="full-calendar-date"
          class="form-control"
          type="date"
          [min]="today | date:'yyyy-MM-dd'"
          (change)="onDateChange($any($event.target).value)">
    </div>
</div>

